<template>
  <a-card :bordered="false">
    <div class="tabs-container">
      <a-tabs default-active-key="1" @change="tabChange">
        <a-tab-pane key="2" tab="网站设置">
          <form-config
            :configList="configList"
            :title="'网站设置'"
            @handlConfig="handlConfig"
            key="formConfig2"
          ></form-config>
        </a-tab-pane>
        <a-tab-pane key="1" tab="中台配置">
          <form-config
            :configList="configList"
            :title="'中台配置'"
            @handlConfig="handlConfig"
            key="formConfig1"
          ></form-config>
        </a-tab-pane>
        <a-tab-pane key="3" tab="企业微信">
          <form-config
            :configList="configList"
            :title="'企业微信'"
            @handlConfig="handlConfig"
            key="formConfig3"
          ></form-config>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-card>
</template>
<script>
import formConfig from './formConfig.vue';
import { getAppointApiConfig } from '@/api/system';
export default {
  data() {
    return {
      configList: [],
      currentKey: 1,
    };
  },
  components: {
    formConfig,
  },
  created() {
    this.initConfig(this.currentKey);
  },
  methods: {
    initConfig(type) {
      getAppointApiConfig({ type: type }).then((res) => {
        if (res.success) {
          this.configList = res.result ? res.result : [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    tabChange(index) {
      this.currentKey = index;
      this.initConfig(index);
    },
    handlConfig() {
      this.initConfig(this.currentKey);
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="less" scoped>
.tabs-container {
  width: 100%;
  height: 100%;
}
::v-deep.ant-card {
  height: 100%;
  .ant-card-body {
    height: 100%;
    padding-bottom: 0;
    .ant-tabs {
      height: 715px;
      display: flex;
      flex-direction: column;
      .ant-tabs-content {
        min-height: 667px;
      }
      .ant-tabs-top-bar {
        height: 48px;
      }
    }
  }
}
</style>
